module.exports = __webpack_public_path__ + "assets/favicon-bf-se.b3d1a964.png";